<template>
    <div>
        <!-- 登录弹框 -->
        <el-dialog :visible.sync="loginAndCreateDialog" @opened="initializeGoogleSignIn" center
            :close-on-click-modal="true" @closed="closeDialog()" custom-class="dialog_normallogin"
            :append-to-body="true">
            <div class="flex_between_box log_login">

                <div class="dialog_cont">
                    <div class="login-left-blue"></div>
                    <div class="login-content">
                        <div class="popTitle"><img src="../assets/images/left-logo.png" alt="" @click="goHome()"></div>
                        <el-tabs v-model="tabType" class="login_tabs flex_center_col">
                            <el-tab-pane label="Sign in" name="login">
                                <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="accunt_form"
                                    style="width: 37.142rem;">
                                    <div class="err_bg" v-show="errFlag">
                                        <img src="../assets/img/err_ic.png" />
                                        {{ errLogTxt }}
                                    </div>
                                    <el-form-item prop="username" class="fist_form_item" label="Email Address">
                                        <el-input v-model="loginForm.username" placeholder="Enter your email address"
                                            maxlength="50"></el-input>
                                    </el-form-item>

                                    <el-form-item prop="password" class="last_form_item password_item" label="Password">
                                        <el-input v-model.trim="loginForm.password" :type="type"
                                            placeholder="Enter your password" @focus="errFlag = false" maxlength="20"
                                            @keyup.enter.native="submitLoginForm('loginForm')">
                                            <i slot="suffix" class="icon_watch"
                                                :class="inputType ? 'icon_watchun' : 'icon_watchon'"
                                                @click="inputType = !inputType"></i>
                                        </el-input>
                                    </el-form-item>
                                    <div>
                                        <div class="flex_between_box log_check">
                                            <!-- <el-checkbox v-model="loginForm.Rememberchecked">
                                                Remember me

                                            </el-checkbox> -->
                                            <div class="cur_pointer" @click="goToForgotPass()">Forgot password?</div>
                                        </div>
                                    </div>

                                    <el-form-item>
                                        <!-- loginForm.checked -->
                                        <el-button class="btn_form_log" :class="{ blue: true }"
                                            @click="submitLoginForm('loginForm')">Sign In</el-button>
                                        <el-form-item prop="" class="log_check policy_txt">
                                            <!-- <el-checkbox v-model="loginForm.checked"> -->
                                            By clicking Sign In, I agreed to CSI's
                                            <span @click="agree()" class="forgot_txt">Privacy Policy</span>
                                            and&nbsp;
                                            <span @click="agree()" class="forgot_txt">Terms & <br> Conditions.</span>
                                            <!-- </el-checkbox> -->
                                        </el-form-item>

                                        <div class="">
                                            <div class="Quicklogin ">or</div>
                                            <div class="Quicklogin-img">

                                                <el-button class="btn_form_log goolebg">


                                                    <p class="flex_center" style="position: relative;">
                                                        <img class="apple_img" style="position: absolute;left: 30%;"
                                                            src="../assets/images/google.png" alt="" />
                                                        <span class="g_id_signin" data-locale="en_US" data-size="large"
                                                            data-theme="outline" data-type="standard"
                                                            data-text="sign_in_with" ref="loginButton">

                                                        </span>
                                                        <span style="position: absolute;left: 40%;z-index: 1;"> Sign in
                                                            with Google</span>
                                                    </p>


                                                </el-button>


                                            </div>
                                            <div class="Quicklogin-img">
                                                <el-button class="btn_form_log goolebg">
                                                    <p class="flex_center"><img class="apple_img"
                                                            src="../assets/images/apple.png" alt="" />
                                                        <span id="appleid-signin" data-color="black" data-border="true"
                                                            data-type="sign in" @click="signInWithApple">Log in with
                                                            Apple</span>

                                                    </p>
                                                </el-button>
                                            </div>
                                            <div class="account">
                                                Don't have an account ? &nbsp;
                                                <span @click="CreateAccount()" class="forgot_txt"> Create your
                                                    account</span>
                                            </div>

                                        </div>
                                    </el-form-item>
                                </el-form>
                            </el-tab-pane>
                            <el-tab-pane label="Create an Account" name="createAccount">
                                <el-form :model="createAccountForm" :rules="createAccountRules" ref="createAccountForm"
                                    class="accunt_form">
                                    <div class="err_bg1" v-show="errCreateFlag">
                                        <img src="../assets/img/err_ic.png" />
                                        {{ errCreateTxt }}
                                    </div>
                                    <div class="err_forgot1 tip_sucess" v-show="sucessCreaSendCode">
                                        <img src="../assets/img/sucess_ic.png" />
                                        {{ sucessCreaSendCodeTxt }}
                                    </div>
                                    <el-form-item prop="account" class="fist_form_item1" label="Email Address">
                                        <el-input v-model="createAccountForm.account" placeholder="Email"
                                            maxlength="50"></el-input>
                                    </el-form-item>
                                    <div class="flex_between_box">
                                        <el-form-item prop="firstName" class="mr20" style="width:50%;"
                                            label="First Name">
                                            <el-input autocomplete="off" v-model="createAccountForm.firstName"
                                                placeholder="Enter your First Name…" maxlength="50"></el-input>
                                        </el-form-item>
                                        <el-form-item prop="lastName" class="" style="width:50%;" label="Last Name">
                                            <el-input autocomplete="off" v-model="createAccountForm.lastName"
                                                placeholder="Enter your Last Name…" maxlength="50"></el-input>
                                        </el-form-item>
                                    </div>
                                    <el-form-item prop="passwordOne" label="Password" class="password_item pass_vail">
                                        <el-input autocomplete="off" v-model.trim="createAccountForm.passwordOne"
                                            :type="type" placeholder="password" @focus="errFlag = false" maxlength="20">
                                            <i slot="suffix" class="icon_watch"
                                                :class="inputType ? 'icon_watchun' : 'icon_watchon'"
                                                @click="inputType = !inputType"></i>
                                        </el-input>
                                    </el-form-item>
                                    <div class="intensity">
                                        <div> <span class="progress"
                                                :class="[level.includes('low') ? 'low' : level.includes('red') ? 'red' : '']"><i
                                                    class="el-icon-circle-check"></i>&nbsp;8 or more characters</span>
                                            <span class="progress"
                                                :class="[level.includes('number') ? 'number' : level.includes('numberred') ? 'numberred' : '']"><i
                                                    class="el-icon-circle-check"></i>&nbsp;At least one number</span>
                                        </div>
                                        <div>
                                            <span class="progress"
                                                :class="[level.includes('lowercase') ? 'lowercase' : level.includes('lowercasered') ? 'lowercasered' : '']"><i
                                                    class="el-icon-circle-check"></i>&nbsp;At least one lowercase
                                                letter</span>

                                            <span class="progress"
                                                :class="[level.includes('uppercase') ? 'uppercase' : level.includes('uppercasered') ? 'uppercasered' : '']"><i
                                                    class="el-icon-circle-check"></i> &nbsp;At least one uppercase
                                                letter</span>

                                        </div>
                                        <!-- <div class="warning_txt">  Password shall not be less than 6 digits</div>
                                <div class="warning_txt">The password must contain numbers, upper and lower case letters, 6-20 digits</div> -->
                                    </div>
                                    <el-form-item prop="passwordTwo" label="Confirm password" class="password_item">
                                        <el-input autocomplete="off" v-model.trim="createAccountForm.passwordTwo"
                                            placeholder="Confirm Password" @focus="errFlag = false" :type="conInputType"
                                            maxlength="20">
                                            <i slot="suffix" class="icon_watch"
                                                :class="conInputType != 'password' ? 'icon_watchun' : 'icon_watchon'"
                                                @click="showconfirmPwd"></i>
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item prop="checked" class="log_check">
                                        <el-checkbox v-model="createAccountForm.checked">
                                            By clicking Sign In, I agreed to CSI's
                                            <span @click="agree(); createAccountForm.checked = true"
                                                class="forgot_txt">Privacy Policy</span>
                                            and&nbsp;
                                            <span @click="agree(); createAccountForm.checked = true"
                                                class="forgot_txt">Terms & <br> Conditions.</span>
                                        </el-checkbox>
                                    </el-form-item>
                                    <!-- btn_mar_top -->
                                    <el-form-item class="register_item">
                                        <el-button class="btn_form_log" :class="{ blue: createAccountForm.checked }"
                                            @click="submitCreateForm('createAccountForm')">Register</el-button>
                                    </el-form-item>
                                    <div class="account">
                                        Already have an account? &nbsp;
                                        <span
                                            @click="tabType = 'login', inputType = false, conInputType = 'password', errFlag = false"
                                            class="forgot_txt"> Login.</span>
                                    </div>
                                </el-form>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="login-left-blue" style="right:0px;bottom:0px"></div>
                </div>
                <div class="login-right">
                    <div class="login-right-desc"></div>
                </div>
            </div>
        </el-dialog>

        <!-- 忘记密码弹框 -->
        <el-dialog :visible.sync="forgotDialog" center :close-on-click-modal="true" @closed="closeDialog()"
            custom-class="dialog_normallogin" :append-to-body="true">
            <div class="dialog_cont forgotDialog_count">
                <div class="forgot_img"><img class="forgot_img_box" src="../assets/images/left-logo.png" alt="">
                </div>
                <div class="forgotDialog-box">
                    <div style="width: 520px;position: relative;">
                        <div class="err_forgot tip_sucess" v-show="errFlagForSucess">
                            <img src="../assets/img/sucess_ic.png" />
                            {{ sussFlagForErrTxt }}
                        </div>
                        <div class="err_forgot tip_error" v-show="errFlagForErr">
                            <img src="../assets/img/err_ic.png" />
                            {{ errFlagForErrTxt }}
                        </div>

                        <div v-if="step2Show" class="popTitletwo">
                            <p class="popTitletwo-text">Reset Password</p>
                            <div class="popTitle-head">Your new password should be different from your old one.</div>
                            <div class="popTitle-img"><img src="../assets/images/passreset.png" alt=""></div>
                        </div>
                        <div v-else class="popTitletwo">
                            <p class="popTitletwo-text">Forgot Password ?</p>
                            <div class="popTitle-head">Enter your email address that you use with your account.</div>
                            <div class="popTitle-img"><img src="../assets/images/password.png" alt=""></div>
                        </div>
                        <el-form :model="forgotForm" :rules="forgotFormRules" ref="forgotForm">
                            <div class="step1" v-if="step1Show">
                                <el-form-item prop="account" class="" label="Email Address">
                                    <el-input v-model="forgotForm.account" placeholder="Enter Email Address"
                                        maxlength="50"></el-input>
                                </el-form-item>
                                <el-form-item prop="code" label="Verification Code">
                                    <el-input autocomplete="off" v-model="forgotForm.code" class="send_code_mar"
                                        placeholder="Enter the verification code" maxlength="6"></el-input>
                                    <span class="send_txt" v-show="setTimeForFlag" @click="sendCodeForgot">
                                        Send verification code
                                    </span>
                                    <div class="send_time" v-show="!setTimeForFlag">{{ setTimeFor }}s</div>
                                </el-form-item>
                                <el-form-item class="btn_mar_top">
                                    <el-button class="btn_form_log" style="border: none;"
                                        :class="{ blue: forgotForm.code }" @click="next()">Next
                                        Step</el-button>
                                </el-form-item>
                            </div>
                            <div class="step2" v-if="step2Show">
                                <el-form-item prop="newPasswordOne" class="fist_form_item password_item"
                                    label="New Password">
                                    <el-input autocomplete="off" v-model.trim="forgotForm.newPasswordOne" :type="type"
                                        placeholder=" Enter your New Password" @focus="errFlag = false" maxlength="20">
                                        <i slot="suffix" class="icon_watch"
                                            :class="inputType ? 'icon_watchun' : 'icon_watchon'"
                                            @click="inputType = !inputType"></i>
                                    </el-input>
                                </el-form-item>

                                <el-form-item prop="newPasswordTow" label="Confirm New Password">
                                    <el-input autocomplete="off" v-model.trim="forgotForm.newPasswordTow"
                                        placeholder="Enter your password again" @focus="errFlag = false"
                                        :type="conInputType" maxlength="20">
                                        <i slot="suffix" class="icon_watch"
                                            :class="conInputType != 'password' ? 'icon_watchun' : 'icon_watchon'"
                                            @click="showconfirmPwd"></i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item class="btn_mar_top">
                                    <el-button class="btn_form_log" :class="{ blue: true }"
                                        @click="submitForgotForm('forgotForm')">Save Password</el-button>
                                </el-form-item>
                            </div>
                            <div class="step3"> Back to <span class="forgot_txt" @click="goToLogin()"> login.</span>
                            </div>

                        </el-form>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- closeDialogagree -->
        <!-- 条款信息 -->
        <DisclamerTranlation :showReport="Agreement" @closeReportDialog="closeDialogagree($event)">
        </DisclamerTranlation>
        <!-- <Vue-recaptcha sitekey="6LfWSc0rAAAAAPVzEshZSH8q-k8MOBs7M9hlXRC6" :loadRecaptchaScript="false"
            @verify="onVerify" @expired="onExpired" @error="onError">
        </Vue-recaptcha> -->
        <Recapthcalogin :useerName="loginForm.username"></Recapthcalogin>
    </div>
</template>
<script>
import { register, sendEmailCode, checkForgotCode, forgetPassword } from '@/api/api.js';
import { mapGetters, mapActions, mapState } from 'vuex';
import crypto from '../utils/crypto.js';
import bus from './bus';
import { jwtDecode } from "jwt-decode";
import DisclamerTranlation from "../components/DisclaimerTranslation/index.vue"
import Recapthcalogin from '../components/Recaptcha/loginRecaptcha.vue'
// import axios from 'axios';
export default {
    components: { DisclamerTranlation, Recapthcalogin },

    props: {
        loginAndCreatePop: {
            type: Boolean,
            default: false,
        },
    },
    data() {

        var validatePass = (rule, value, callback) => {


            if (value == '') {
                callback(new Error('Invalid password'));
            } else if (value !== this.createAccountForm.passwordOne) {
                callback(new Error('The password you entered does not match'));
            } else {
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {

            if (value === '') {
                callback(new Error('Invalid password'));
            } else if (value !== this.forgotForm.newPasswordTow) {
                callback(new Error('The password you entered does not match'));
            } else {
                callback();
            }

        };
        //邮箱校验
        var validateEmail = (rule, value, callback) => {
            if (value !== '') {
                let reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
                if (!reg.test(value)) {
                    callback(new Error('Invalid account'));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        // 登陆勾选认证
        var checkedyanzheng = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Please check the box to agree the term'));
            } else if (value == false) {
                callback(new Error('Please check the box to agree the term'));
            } else {
                callback();
            }
        };
        var checkedyanzheng1 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Please check the box to agree the term'));
            } else if (value == false) {
                callback(new Error('Please check the box to agree the term'));
            } else {
                callback();
            }
        };
        var validateCode = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please Enter verification code'));
                return;
            }
            if (value.includes(' ')) {
                callback(new Error('The verification code cannot contain spaces'));
                return;
            }
            if (value.length > 6) {
                callback(new Error('The length of the verification code cannot exceed 6 digits'));
                return;
            }
        };
        return {
            Agreement: false,
            //loginAndCreateDialog:false,//登录弹框
            forgotDialog: false, //忘记密码弹框
            timer: null,
            setTime: '',
            setTimeFlag: true, //发送倒计时显示
            timerFor: null,
            setTimeFor: '',
            setTimeForFlag: true,
            tabType: 'login',
            errFlag: false,
            errLogTxt: '',
            errCreateFlag: false,
            errCreateTxt: '',
            sucessCreaSendCode: false,
            sucessCreaSendCodeTxt: '',
            errFlagForSucess: false,
            errFlagForErr: false,
            errFlagForErrTxt: '',
            sussFlagForErrTxt: '',
            inputTypelogin: false,
            inputType: false, //查看密码
            conInputType: 'password', //查看密码
            level: [], //密码强度
            verificationToken: '',
            loginForm: {
                username: '',
                password: '',
                checked: true,
                Rememberchecked: true,

            },
            loginRules: {
                username: [
                    {
                        required: true,
                        message: 'Invalid account',
                        trigger: 'blur',
                    },
                    { validator: validateEmail, trigger: 'blur' },
                ],

                password: [
                    {
                        required: true,
                        message: 'Invalid password',
                        trigger: 'blur',
                    },
                ],
                checked: [
                    {
                        required: true,
                        // message: 'Please checked',
                        validator: checkedyanzheng,
                        trigger: 'blur',
                    },
                ],
            },
            createAccountForm: {
                account: '',
                passwordOne: '',
                passwordTwo: '',
                phone: '',
                code: '',
                checked: true,
                lastName: '',
                firstName: ''
            },
            createAccountRules: {
                account: [
                    {
                        required: true,
                        message: 'Invalid account',
                        trigger: 'blur',
                    },
                    {
                        validator: validateEmail,
                        trigger: 'blur',
                    },
                ],
                firstName: [
                    {
                        required: true,
                        message: 'Invalid first name format',
                        trigger: 'blur',
                    },
                ],
                lastName: [
                    {
                        required: true,
                        message: 'Invalid last name format',
                        trigger: 'blur',
                    },
                ],
                passwordOne: [
                    {
                        required: true,
                        validator: this.checkPassword,
                        trigger: 'change',
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: 'Incorrect phone format',
                        trigger: 'blur',
                    },
                ],
                passwordTwo: [
                    {
                        required: true,
                        validator: validatePass,
                        trigger: 'blur',
                    },
                ],
                code: [
                    {
                        required: true,
                        validator: validateCode,
                        // message: 'The verification code is inaccurate or expired',
                        trigger: 'blur',
                    },
                ],
                checked: [
                    {
                        required: true,
                        validator: checkedyanzheng1,
                        // message: 'Please check the box to agree the term',
                        trigger: 'blur',
                    },
                ],
            },
            forgotForm: {
                account: '',
                code: '',
                newPasswordOne: '',
                newPasswordTow: '',
            },
            forgotFormRules: {
                account: [
                    {
                        required: true,
                        message: 'Invalid account',
                        trigger: 'blur',
                    },
                ],
                code: [
                    {

                        required: true,
                        validator: validateCode,
                        // message: 'The verification code is inaccurate or expired',
                        trigger: 'blur',
                    },
                ],
                newPasswordOne: [
                    {
                        required: true,
                        validator: this.checkPassword,
                        trigger: 'change',
                    },
                ],
                newPasswordTow: [
                    {
                        required: true,
                        validator: validatePass2,
                        trigger: 'blur',
                    },
                ],
            },
            step1Show: true,
            step2Show: false,
            step3Show: false,
            fbSignInParams: {
                scope: 'email,user_likes,public_profile',
                enable_profile_selector: true,
                return_scopes: true,
            },
            window: window,
            savedState: '',
            apiKey: '86p20mqlao9hac',
            loggedIn: false,
            profileData: null,
            googleSignInParams: {
                client_id: '759346761913-g2u0meoujmj7m58sjddon4t47lpkk8i5.apps.googleusercontent.com'
            }
        };

    },
    created() {
        // 谷歌apple登录
        this.loadAppleSDK()

        this.loadGoogleSDK()



        bus.$on('handleShowLogin', loginStatus => {
            this.loginAndCreateDialog = loginStatus;
        });
        bus.$on('Agreement', loginStatus => {
            this.Agreement = loginStatus;
        });
        // 初始化Facebook SDK
        // window.fbAsyncInit = function () {
        //     window.FB.init({
        //         appId: '767514612088787',
        //         cookie: true,
        //         xfbml: true,
        //         version: 'v3.0',
        //     });

        //     window.FB.AppEvents.logPageView();
        // };

        // 加载Facebook SDK的异步函数
        // (function(d, s, id){
        //   var js, fjs = d.getElementsByTagName(s)[0];
        //   if (d.getElementById(id)) {return;}
        //   js = d.createElement(s); js.id = id;
        //   js.src = "https://connect.facebook.net/en_US/sdk.js";
        //   fjs.parentNode.insertBefore(js, fjs);
        // }(document, 'script', 'facebook-jssdk'));
    },
    mounted() {

        if (process.env.NODE_ENV === 'development') { // 如果是开发环境

        }

    },

    computed: {
        ...mapGetters({
            token: 'users/token',
        }),
        ...mapState({
            token: 'users/token',
        }),
        type() {
            return this.inputType ? 'text' : 'password';
        },
        loginAndCreateDialog: {
            get() {
                return this.loginAndCreatePop;
            },
            set(newValue) {
                this.$emit('update:loginAndCreatePop', newValue);
            },
        },
    },
    destroyed() {
        // bus.$off('handleShowLogin');
    },
    methods: {
     
        loadGoogleSDK() {
            const script = document.createElement('script');
            script.src = 'https://accounts.google.com/gsi/client?hl=en_US';
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        },

        // async 苹果登陆  
        loadAppleSDK() {
            return new Promise((resolve) => {

                if (window.AppleID) {
                    resolve(); // 如果已经加载，则直接返回
                    return;
                }
                const script = document.createElement('script');
                script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
                script.onload = () => {
                    window.AppleID.auth.init({
                        response_mode: 'form_post',
                        response_type: 'code',
                        // scope: 'openid',
                        clientId: 'com.csiInc.csi', // 替换为你的 Services ID
                        scope: 'email name',
                        // scope: 'openid email name',
                        redirectURI: "https://www.csibizsearch.com/csi/third/apple/callback", // 替换为你的回调 URL
                        // https://api.csibizsearch.com/auth/apple/callback
                        state: 'state',
                        usePopup: true // 使用弹
                        // usePopup: true // 使用弹出窗口
                    });
                    resolve(); // 加载完成后解析
                };
                // script.async = true;
                // script.defer = true;
                document.head.appendChild(script);
            });
        },

        signInWithApple() {
            window.AppleID.auth.signIn().then((response) => {
                // 处理成功的登录

                let params = {
                    clientId: 'com.csiInc.csi',
                    idToken: response.authorization.id_token
                }
                this.LoginSubmitApple(params).then(res => {
                    if (res.code) {
                        this.resetSetItem('token', res.data.token);
                        this.errFlag = false;
                        this.errLogTxt = '';
                        this.loginAndCreateDialog = false;
                        this.$message({
                            message: res.msg,
                            center: true,
                            type: 'success',
                        });
                        bus.$emit('handleLogin', true); //是否显示登录
                        this.$emit('getLoginStatus', true);

                    } else {
                        this.$emit('getLoginStatus', false);
                        this.errFlag = true;
                        this.errLogTxt = res.msg;

                        return false;
                    }
                });


                // this.verifyToken(idToken); // 调用后端验证
            }).catch((error) => {
                console.error('Apple Sign In Error:', error);
            });
        },
        initializeGoogleSignIn() {
            // 使用 Google API 创建登录按钮

            window.google.accounts.id.initialize({
                // client_id: '759346761913-g2u0meoujmj7m58sjddon4t47lpkk8i5.apps.googleusercontent.com',
                client_id: '759346761913-g2u0meoujmj7m58sjddon4t47lpkk8i5.apps.googleusercontent.com',
                // redirect_uri:'https://www.csibizsearch.com/',
                callback: this.handleCredentialResponse,
            });
            this.$nextTick(() => {
                window.google.accounts.id.renderButton(
                    this.$refs.loginButton, // 使用 ref 引用
                    { theme: 'outline', size: 'large', logo_alignment: 'center', width: 800, locale: "zh_en" } // 按钮样式
                );
            })
        },
        handleCredentialResponse(response) {
            const credential = response.credential;
            let params = {
                clientId: '759346761913-g2u0meoujmj7m58sjddon4t47lpkk8i5.apps.googleusercontent.com',
                idToken: credential,
                email: jwtDecode(credential).email
            }
            this.LoginSubmitGoole(params).then(res => {
                if (res.code) {
                    this.resetSetItem('token', res.data.token);
                    this.errFlag = false;
                    this.errLogTxt = '';
                    this.loginAndCreateDialog = false;
                    this.$message({
                        message: res.msg,
                        center: true,
                        type: 'success',
                    });
                    bus.$emit('handleLogin', true); //是否显示登录
                    this.$emit('getLoginStatus', true);

                } else {
                    this.$emit('getLoginStatus', false);
                    this.errFlag = true;
                    this.errLogTxt = res.msg;

                    return false;
                }
            });


        },
        CreateAccount() {

            this.tabType = 'createAccount'
            this.inputType = false
            this.createAccountForm = {
                account: '',
                passwordOne: '',
                passwordTwo: '',
                phone: '',
                code: '',
                checked: true,
                lastName: '',
                firstName: ''
            }
            this.errCreateFlag = false
            this.$refs.createAccountForm.resetFields()
        },
        initializeLinkedInSDK() {
            this.window.IN.init({
                api_key: '86p20mqlao9hac',
                authorize: true,
            });
        },
        lingIn() {
            let that = this;
            return new Promise((resolve, reject) => {
                that.window.IN.User.authorize(() => {
                    // 登录成功后的回调处理
                    this.getUserProfile()
                        .then(userInfo => resolve(userInfo))
                        .catch(error => reject(error));
                });
            });
        },
        getUserProfile() {
            let that = this;
            return new Promise((resolve, reject) => {
                if (that.window.IN.User.isAuthorized()) {
                    that.window.IN.IN.API.Profile('me')
                        .fields('id,firstName,lastName,emailAddress')
                        .result(result => {
                            // 处理获取到的用户信息
                            const userInfo = result.values[0];
                            resolve(userInfo);
                        })
                        .error(error => {
                            // 处理错误
                            reject(error);
                        });
                } else {
                    reject(new Error('User is not authorized'));
                }
            });
        },

        //       lingIn(){
        //            const clientId = '86p20mqlao9hac';
        //       const redirectUri = 'http://localhost:9098/';
        //       const scope = ['r_liteprofile', 'r_emailaddress']

        //       window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope.join('%20')}`;

        //   window.addEventListener('message', (event) => {
        //         if (event.origin === window.location.origin) {
        //           const code = event.data;
        // console.log(code);
        //           // 使用授权码获取访问令牌
        //           this.getAccessToken(code);
        //         }
        //       });
        //       },
        //        getAccessToken(code) {
        //           // 在LinkedIn开发者平台上注册的应用程序的客户端ID
        //           const clientId = '86p20mqlao9hac';

        //           // 在LinkedIn开发者平台上注册的应用程序的客户端密钥
        //           const clientSecret = 'gQS4W3W31KYmTBnm';

        //           // 在LinkedIn开发者平台上注册的应用程序的回调URL
        //           const redirectUri = 'http://localhost:9098/';

        //           // 构建获取访问令牌的URL
        //           const tokenUrl = 'https://www.linkedin.com/oauth/v2/accessToken';

        //           // 发送POST请求获取访问令牌
        //           axios.post(tokenUrl, null, {
        //             params: {
        //               grant_type: 'authorization_code',
        //               code: code,
        //               client_id: clientId,
        //               client_secret: clientSecret,
        //               redirect_uri: redirectUri,
        //             },
        //           })
        //           .then((response) => {
        //             const accessToken = response.data.access_token;
        //             // 使用访问令牌进行后续API调用或保存到本地进行身份验证
        //           })
        //           .catch((error) => {
        //             // 处理错误情况
        //           });
        //         },

        // Facebook
        facebooklogin() {
            this.window.FB.logout(function (response) {
            });
        },
        // onSignInSuccess(response) {
        //     this.window.FB.api('/me?fields=id,name,gender,first_name,last_name,email,birthday,hometown', dude => { });
        //     window.FB.api('/me', { fields: 'name,email,id,first_name,birthday,picture' }, res => {
        //         console.log(`res`, res);
        //         const name = response.name;
        //         const email = response.email;

        //         // 在这里可以将用户信息发送到后端进行进一步处理或验证
        //     });
        //     // https://developers.facebook.com/docs/graph-api/reference/user

        //     console.log(response); //返回第三方的登录信息 tolen等
        // },
        onSignInError(error) { },

        // 注册条款
        agree() {
            this.createAccountForm.checked = true
            // this.forgotForm.code=true
            this.Agreement = true;
        },
        ...mapActions({
            LoginSubmit: 'users/LoginSubmit',
            LoginSubmitGoole: 'users/LoginSubmitGoole',
            LoginSubmitApple: 'users/LoginSubmitApple'
            // connectWebSocket: 'websocket/connectWebSocket',
        }),
        //接受兄弟组件传值

        //发送验证码
        sendCode() {
            this.errCreateFlag = false;
            if (this.createAccountForm.account == '') {
                this.errCreateFlag = true;
                this.errCreateTxt = 'Invalid account';
                return;
            }
            this.checkaccount();
            // .then(res => {
            //     if (res && res.code) {
            //         console.log(res);
            //         this.errCreateFlag = false;
            //         this.sucessCreaSendCodeTxt = res.msg;
            //         this.sucessCreaSendCode = true;
            //     } else {
            //         this.sucessCreaSendCodeTxt = '';
            //         this.sucessCreaSendCode = false;
            //     }
            // });
        },
        goHome() {
            this.loginAndCreateDialog = false
            this.$router.push('/')
        },
        //倒计时
        async checkaccount() {

            const params = {
                email: this.createAccountForm.account,
                source: '1',
            };
            const codeRes = await sendEmailCode(params);
            if (codeRes.code == 200) {
                this.errCreateFlag = false;
                this.sucessCreaSendCodeTxt = codeRes.msg;
                this.sucessCreaSendCode = true;
                if (!this.timer) {
                    const time = 300;
                    this.setTime = time;
                    this.setTimeFlag = false;
                    this.timer = setInterval(() => {
                        if (this.setTime > 1 && this.setTime <= time) {
                            this.setTime--;
                        } else {
                            this.setTimeFlag = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000);
                }
            } else {
                this.sucessCreaSendCodeTxt = '';
                this.sucessCreaSendCode = false;
                this.errCreateFlag = true;
                this.errCreateTxt = codeRes.msg;
                this.$message.error(codeRes.msg)
                //
            }
        },
        // 发送验证码
        sendCodeForgot() {
            this.errFlagForSucess = false;
            this.errFlagForErr = false;
            if (this.forgotForm.account == '') {
                return;
            }
            this.checkForgot();
        },
        //倒计时
        async checkForgot() {

            // this.errFlagForSucess = true;
            const params = {
                email: this.forgotForm.account,
                source: '3',
            };
            const codeRes = await sendEmailCode(params);
            if (codeRes.code == 200) {
                this.errFlagForSucess = true;
                this.sussFlagForErrTxt = codeRes.msg;
                if (!this.timerFor) {
                    const time = 60;
                    this.setTimeFor = time;
                    this.setTimeForFlag = false;
                    this.timerFor = setInterval(() => {
                        if (this.setTimeFor > 1 && this.setTimeFor <= time) {
                            this.setTimeFor--;
                        } else {
                            this.setTimeForFlag = true;
                            clearInterval(this.timerFor);
                            this.timerFor = null;
                        }
                    }, 1000);
                }
            } else {
                this.errFlagForErr = true;
                this.errFlagForErrTxt = codeRes.msg;
                this.$message.error(codeRes.msg)
            }
        },
        //忘记密码下一步，第一步
        async next() {

            if (this.forgotForm.code != '' && this.forgotForm.account != '') {
                const params = {
                    account: this.forgotForm.account,
                    source: '3',
                    code: this.forgotForm.code,
                };
                let res = await checkForgotCode({
                    verificationCode: this.forgotForm.code,
                    account: this.forgotForm.account
                });

                //  =true
                if (res.code == 200) {
                    this.verificationToken = res.data
                    this.errFlagForErr = false;
                    this.errFlagForErrTxt = '';
                    this.step1Show = false;
                    this.step2Show = true;
                } else {
                    this.verificationToken = ''
                    this.errFlagForErr = true
                    this.errFlagForSucess = false
                    this.sussFlagForErrTx = ''
                    this.errFlagForErrTxt = res.msg;
                    // this.$message.error(res.msg)
                }
            }

            //         }
            //     });
        },
        //去登录
        goToLogin() {
            this.loginAndCreateDialog = true;
            this.forgotDialog = false;

            this.tabType = 'login';

            this.$refs.loginForm.resetFields();
            this.inputType = false;
        },
        //去忘记密码
        goToForgotPass() {
            this.forgotDialog = true;
            this.loginAndCreateDialog = false;
            this.inputType = false;
            this.step1Show = true;
            this.step2Show = false;
            this.step3Show = false;
            this.level = []; //密码强度等级
        },
        //关闭弹窗初始化
        closeDialog() {
            this.errFlag = false;
            this.errFlagForSucess = false;
            this.errFlagForErr = false;
            this.inputType = false; //查看密码
            this.conInputType = 'password'; //查看密码
            this.tabType = 'login';
            this.$nextTick(() => {
                if (this.$refs.loginForm !== undefined) this.$refs.loginForm.resetFields();
                if (this.$refs.createAccountForm !== undefined) this.$refs.createAccountForm.resetFields();
                if (this.$refs.forgotForm !== undefined) this.$refs.forgotForm.resetFields();
            });
            this.createAccountForm.checked = true
        },
        closeDialogagree() {
            this.Agreement = false;
            this.createAccountForm.checked = true
        },
        //提交忘记表单
        submitForgotForm(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    this.errFlagForSucess = false;
                    const params = {
                        account: this.forgotForm.account,
                        newPasswordOne: crypto.encrypt(this.forgotForm.newPasswordOne),
                        newPasswordTow: crypto.encrypt(this.forgotForm.newPasswordTow),
                        verificationToken: this.verificationToken
                    };
                    let res = await forgetPassword(params);
                    if (res.code == 200) {
                        this.errFlagForErr = false;
                        this.step1Show = false;
                        this.step2Show = false;
                        this.step3Show = true;
                        this.$message({
                            message: res.msg,
                            center: true,
                            type: 'success',
                        });
                        this.goToLogin()
                    } else {
                        // this.$message({
                        //     message: res.msg,
                        //     center: true,
                        //     type: 'error',
                        // });
                        this.errFlagForErr = true;
                        this.errFlagForErrTxt = res.msg;
                    }
                } else {
                    return false;
                }
            });
        },
        //登录
        login() {
            if (!this.loginForm.checked) {
                return;
            }
            const params = {
                email: this.loginForm.username,
                password: crypto.encrypt(this.loginForm.password),
            };
            this.LoginSubmit(params).then(res => {
                if (res.code == 200) {

                    this.resetSetItem('token', res.data.token);
                    this.errFlag = false;
                    this.errLogTxt = '';
                    this.loginAndCreateDialog = false;
                    this.$message({
                        message: res.msg,
                        center: true,
                        type: 'success',
                    });
                    bus.$emit('handleLogin', true); //是否显示登录
                    this.$emit('getLoginStatus', true);
                    // this.$bus.$emit('loginabouttrue', true);
                    // this.connectWebSocket(res.data.userInfo.userCode);
                } else {
                    this.errFlag = true;
                    this.errLogTxt = res.msg;
                    this.$emit('getLoginStatus', false);

                    // this.$message({
                    //     message: res.msg,
                    //     center: true,
                    //     type: 'error',
                    // });
                    return false;
                }
            });
        },
        // 提交登陆
        submitLoginForm(formName) {
            this.$refs[formName].validate(valid => {
              
                if (valid) {
                    this.login();
                    // 机器验证
            //    this.$bus.$emit('show-CaptchaPage-dialog', true);

                } else {
                    return false;
                }
            });
        },

        //提交注册
        submitCreateForm(formName) {
            this.errFlag = false;
            this.$refs[formName].validate(valid => {
                if (valid && this.createAccountForm.checked) {
                    this.errFlag = false;
                    this.createAccount();
                } else {
                    this.$refs[formName].validate(res => {
                        // console.log(`res`, res);
                    });
                    // callback(new Error('请再次输入密码'));
                    return false;
                }
            });
        },
        //注册
        async createAccount() {
            const params = {
                email: this.createAccountForm.account,
                code: this.createAccountForm.code,
                firstName: this.createAccountForm.firstName,
                lastName: this.createAccountForm.lastName,
                passwordOne: crypto.encrypt(this.createAccountForm.passwordOne),
                passwordTwo: crypto.encrypt(this.createAccountForm.passwordTwo),
            };
            let res = await register(params);

            if (res.code == 200) {
                this.errCreateFlag = false;
                this.$message({
                    message: res.msg,
                    center: true,
                    type: 'success',
                });
                const params1 = {
                    username: this.createAccountForm.account,
                    password: '',
                };
                this.loginForm.username = this.createAccountForm.account
                this.loginForm.password = ''
                this.tabType = 'login';

            } else {
                // this.$message({
                //     message: res.msg,
                //     center: true,
                //     type: 'error',
                // });
                this.errCreateFlag = true;
                this.errCreateTxt = res.msg;
                return false;
            }
        },
        //点击小眼睛
        showconfirmPwd() {

            if (this.conInputType === 'password') {
                this.conInputType = 'text';
            } else {
                this.conInputType = 'password';
            }
        },

        // 校验密码
        checkPassword(rule, value, callback) {
            this.level = [];
            if (!value) {
                return callback('Invalid password');
            }
            if (value.length > 20) {
                return callback('The password is no more than 20 digits');
            }
            // 校验是数字
            const regex1 = /^\d+$/;
            // 校验字母
            const regex2 = /^[A-Za-z]+$/;
            const regnum = /[0-9]/
            const lowercase = /[a-z]/
            const uppercase = /[A-Z]/
            // 校验符号
            const regex3 = /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]+$/; // eslint-disable-line
            const regex4 = /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、\d]+$/; // eslint-disable-line
            const regex5 = /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、A-Za-z]+$/; // eslint-disable-line
            const regex6 = /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、A-Za-z\d]+$/; // eslint-disable-line
            if (lowercase.test(value)) {
                this.level.push('lowercase');
            } else {
                this.level.push('lowercasered');
                callback('At least one lowercase letter');
            } if (uppercase.test(value)) {
                this.level.push('uppercase');
            } else {
                this.level.push('uppercasered');
                callback('Password At least one uppercase letter');

            }
            if (regnum.test(value)) {

                this.level.push('number');
            } else {
                this.level.push('uppercasered');
                callback('Password At least one number letter');
            }
            if (value.length >= 8) {
                this.level.push('low');
            } else {
                this.level.push('red');
                callback('Password shall not be less than 8 digits');
            }


            // if (value.length>8) {
            //     this.level.push('low');
            // } else if (/[a-z]/.test(value)) {
            //     this.level.push('lowercase ');
            // } else if (regex3.test(value)) {
            //     this.level.push('low');
            // } else if (/^[A-Za-z\d]+$/.test(value)) {
            //     this.level.push('low');
            //     this.level.push('middle');
            // } else if (regex4.test(value)) {
            //     this.level.push('low');
            //     this.level.push('middle');
            // } else if (regex5.test(value)) {
            //     this.level.push('low');
            //     this.level.push('middle');
            // } else if (regex6.test(value)) {
            //     this.level.push('low');
            //     this.level.push('middle');
            //     this.level.push('high');
            //       this.level.push('lowercase');
            // }
            return callback();
        },
    },
};
</script>
<style scoped>
/**
* 这里的font-size嵌套了太多层了，没法计算了，所以直接改为rem了
 */


.login_tabs /deep/ .el-tabs__active-bar.is-top,
.login_tabs /deep/ .el-tabs__nav-wrap::after {
    display: none;
}

.login_tabs /deep/ .el-tabs__item {
    height: 1.5714rem;
    font-size: 1.2857rem;
    color: #022955;
    line-height: 1.2857rem;
    padding: 0 0.9285rem;
}

.login_tabs /deep/ .el-tabs__item::after {
    content: '';
    position: absolute;
    right: 0;
    top: 4px;
    width: 1px;
    height: 0.7857rem;
    background-color: #8497ab;
}

.login_tabs /deep/ .el-tabs__item:last-child::after {
    display: none;
}

.login_tabs /deep/ .el-tabs__header {
    margin: 1.142857em auto 4px;
}

.login_tabs /deep/ .el-tabs__item.is-top.is-active {
    color: #1290c9;
}

.login_tabs /deep/ .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
    display: none;
}

.err_bg {
    width: 100%;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-image: url(data:image/png;base64,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); */
    background-repeat: no-repeat;
    background-size: 25.71rem;
    color: #f05050;
    font-size: 1.2857rem;
    background: linear-gradient(270deg, rgba(255, 162, 162, 0.08) 0%, #FFD7D7 61%, rgba(255, 173, 173, 0.18) 100%);
    /* background-color: red; */
    text-align: center;
    position: absolute;
    top: 0.714rem;
}

.err_forgot {
    width: 100%;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-image: url(data:image/png;base64,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); */
    background-repeat: no-repeat;
    background-size: 25.71rem;
    color: #f05050;
    font-size: 1.2857rem;
    background: linear-gradient(270deg, rgba(255, 162, 162, 0.08) 0%, #FFD7D7 61%, rgba(255, 173, 173, 0.18) 100%);
    /* background-color: red; */
    text-align: center;
    position: absolute;
    top: -43px;
}

.err_forgot1 {
    width: 100%;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-image: url(data:image/png;base64,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); */
    background-repeat: no-repeat;
    background-size: 25.71rem;
    color: #f05050;
    font-size: 1.2857rem;
    background: linear-gradient(270deg, rgba(255, 162, 162, 0.08) 0%, #FFD7D7 61%, rgba(255, 173, 173, 0.18) 100%);
    /* background-color: red; */
    text-align: center;
    position: absolute;
    top: -43px;
}

.err_bg1 {
    width: 99%;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-image: url(data:image/png;base64,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); */
    background-repeat: no-repeat;
    /* background-size: 25.71rem; */
    color: #f05050;
    font-size: 1.2857rem;
    background: linear-gradient(270deg, rgba(255, 162, 162, 0.08) 0%, #FFD7D7 61%, rgba(255, 173, 173, 0.18) 100%);
    /* background-color: red; */
    text-align: center;
    position: absolute;
    top: 0.714rem;
}

.err_bg1 img,
.err_bg img {
    width: 1.2857rem;
    margin-right: 1rem;
}

.dialog_cont /deep/.el-input__inner {
    height: 4.1428rem;
    line-height: 4.1428rem;
    border: none;
    background: #FFFFFF;
    border-radius: 0.714rem;
    border: 1px solid #8497AB;
    padding: 0 1.4285rem;
    font-size: 1.2857rem;
    color: #1A2332;
}

.dialog_cont /deep/ .el-form-item__content {
    line-height: normal;
    font-size: 1.142857rem;
    color: #111111;
}

.dialog_cont /deep/ .el-form-item__label {
    font-size: 1.2857em !important;
    color: #1A2332;
}

.dialog_cont /deep/ .el-form-item {
    /* margin-bottom: 25px; */
    margin-bottom: 2.1428rem;
    position: relative;
    z-index: 999999;
}

.fist_form_item1 {
    margin-top: 70px;
}

.fist_form_item {
    margin-top: 3.571rem;
}

.last_form_item {
    margin-bottom: 1.4285em !important;
}

.password_item /deep/ .el-input__inner {
    padding-right: 3.571rem;
}

.pass_vail {
    margin-bottom: 1.4285em !important;
}

.dialog_cont /deep/ .el-input__suffix-inner {
    width: 1.857rem;
    height: 1.4285rem;
}

.forgot_txt {
    font-size: 1.142857rem;
    color: #1290c9;
    line-height: 1.142857rem;
    text-decoration: underline;
    text-align: right;
    margin-bottom: 2.1428rem;
    position: relative;
    z-index: 10;
    cursor: pointer;
}

.btn_form_log {
    width: 100%;
    height: 58px;
    padding: 0.714rem;
    background: #8497AB;
    /* background: #1290c9; */
    border-radius: 0.714rem;
    font-size: 1.2857rem;
    border: 1px solid #8497AB;
    color: #ffffff;
    text-align: center;
    margin-bottom: 1.4285rem;
}

/deep/ .btn_form_log.el-button:focus,
/deep/ .btn_form_log.el-button:hover {
    border-color: #8497AB;
}

.register_item {
    margin-bottom: 0 !important;
}

.policy_txt {
    margin-bottom: 2.8571em !important;
}

.el-button:focus,
.el-button:hover {
    border-color: #cccccc;
    /* color: #ffffff; */
}

.blue {
    font-family: 'DMSans Bold';
    font-size: 1.5714rem;
    border: none;
    background: #1290c9 !important;
}

.log_check .el-checkbox {
    display: flex;
    white-space: normal;
    color: #1A2332;
}

/deep/ .el-checkbox__label {
    font-size: 1.142857rem;
    color: #1A2332;
    line-height: 1.2857rem;

}

/deep/ .el-checkbox__inner {
    border-radius: 4px;
    width: 1.4285rem;
    height: 1.4285rem;

}

.log_check /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.log_check /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #1290c9;
    border-color: #1290c9;
    border: none;
}

.log_check /deep/ .el-checkbox__inner::after {
    width: 1rem;
    height: 1rem;
    left: 3px;
    top: 3px;
    background-image: url(../assets/img/check_ic.png);
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    border: none;
}

.log_check /deep/ .el-checkbox__input.is-checked .el-checkbox__inner::after {
    transform: rotate(0deg) scaleY(1);
}

.log_check /deep/.el-checkbox__input.is-checked+.el-checkbox__label {
    color: inherit;
}

.log_check /deep/ .el-checkbox__label {
    font-size: 1.142857rem;
}

.send_txt {
    font-size: 1.2857rem;
    color: #1290c9;
    line-height: 2.1428rem;
    position: absolute;
    right: 0.714rem;
    text-align: center;
    border-left: 1px solid #ccc;
    padding-left: 0.714rem;
    top: 3.357rem;
    text-decoration: none;
    cursor: pointer;
}

.cur_pointer {
    cursor: pointer;
    font-size: 1.142857rem;
    color: #1290c9;
    line-height: 1.142857rem;
    text-decoration: underline;
    text-align: right;
    margin-bottom: 2.1428rem;
}

.send_time {
    font-size: 1.142857rem;
    color: #1290c9;
    position: absolute;
    right: 0.714rem;
    top: 3.642rem;
}

.send_code_mar /deep/ .el-input__inner {
    padding-right: 8.57rem;
}

.psdText {
    font-size: 1rem;
    margin-right: 0.714rem;
}

.progress {
    display: block;
    /* width: 40%; */
    margin-bottom: 0.714rem;
    /* margin-top: -10px; */
    font-size: 1.142857rem;
    /* height: 0.714rem; */
    /* background: #dddddd; */
    /* border-radius: 8px; */
    margin-right: 2.1428rem;
    color: #8497AB;
}

.progress:last-of-type {
    margin-right: 0;
}

.low,
.number,
.uppercase,
.lowercase {
    color: #55b419;
}

.red,
.lowercasered,
.numberred,
.uppercasered {
    color: red;
}

.warning_txt {
    margin-top: 0.714rem;
    margin-bottom: 2.1428rem;
    font-size: 1.2857rem;
    line-height: 1.142857rem;
}

.btn_mar_top {
    margin-top: 2.857rem;
}



.err_forgot img {
    width: 1.2857rem;
    margin-right: 4px;
}

.tip_sucess {
    color: #55b419;
    background: transparent;
}

.tip_error {
    color: #f56b6b;
}

.step3 {
    text-align: center;
    font-size: 1.2857rem;
    color: #111111;
    /* margin-top: -25px; */
}

.step3_txt {
    font-size: 1.142857rem;
    line-height: 2.1428rem;
    margin-top: 3.571rem;
    margin-bottom: 5.714rem;
}

/*注册条件 */
.agreement_cont {
    width: 100%;
    max-height: 83vh;
    overflow: auto;
    padding: 3.571em 4rem;
    font-size: 1.2857em !important;
}

.answer-title-italic {
    color: #000;
    font-style: italic;
}

.answer-content {
    padding-left: 3.571rem;
}

.answer-title {
    color: #000;
}

.info1 {
    color: #172434;
    font-size: 1.2857rem;
    text-align: left;
    line-height: 1.5714rem;
    overflow: hidden;
}

.info1box {
    width: 60rem;
    line-height: 1.5714rem;
    color: #585d64;
    font-size: 1.2857rem;
    text-align: left;

    word-break: keep-all;
}

.question {
    color: #1290c9;
    font-size: 1.2857rem;
}

.amail-style {
    color: #1290c9;
    border-bottom: 1px solid #1290c9;
}

.answer-ul {}

.agreement_cont /deep/ .el-tabs__item {
    font-size: 1.2857rem;
    color: #022955;

}

.agreement_cont /deep/.el-tabs__item.is-active,
.agreement_cont /deep/.el-tabs__item:hover {
    color: #1290c9;
}

.agreement_cont /deep/.el-tabs__active-bar {
    background-color: #1290c9;
}

.shake {
    animation: shake 0.5s;
}

@keyframes shake {
    0% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-5px);
    }

    50% {
        transform: translateX(5px);
    }

    75% {
        transform: translateX(-5px);
    }

    100% {
        transform: translateX(0);
    }
}

.login-right {
    width: 52%;
    /* height: 100vh; */
    background: url("../assets/img/login_bg.png") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
}

.login-right-desc {
    width: 78%;
    height: 89%;
    margin: 5.5% 0 5.5% 7.2%;
    background: url("../assets/img/login_desc1.png") no-repeat;
    background-size: contain;
    background-position: center center;
}

.login-left-blue {
    width: 48%;
    height: 40%;
    background: #1290C9;
    opacity: 0.13;
    filter: blur(3.571em);
    position: absolute
}

.login-content {
    /* position: relative; */
    z-index: 9999;
    /* width: 65%; */
    width: 37.142rem;
    margin: auto;
    overflow: hidden;
    /* margin-top: 12%; */
    /* margin-top: 10%; */
    /* margin-top: -30%; */
}

.popTitle {
    height: 3.1428rem;
    width: 20rem;
    margin: auto;
    margin-top: 10% !important;
    cursor: pointer;

}

.popTitletwo {
    width: 100%;
    margin: auto;
    text-align: center;
}

.popTitletwo-text {
    font-size: 2.571rem;
    color: #1A2332;
    line-height: 2.857rem;
    font-family: 'DMSans Bold';

}

.popTitle-head {
    font-size: 1.2857rem;
    color: #1A2332;
    line-height: 1.4285rem;
    margin-top: 2.1428rem;
    margin-bottom: 0.714rem;
}

.popTitle-img {
    height: 6.07rem;
}

.popTitle img {
    width: 100%;
    height: 100%;
}

/* login-kuaijie */
.info1box {
    width: 100% !important;
}

.Quicklogin {
    text-align-last: center;
    margin: 2.857rem auto;
    color: #8497AB;
    font-size: 1.142857rem;
}

.fb-signin-button {
    text-align: center;
    margin-right: 0.714rem;
}

.Quicklogin::before,
.Quicklogin::after {
    content: '';
    position: absolute;
    top: 42%;
    width: 46%;
    height: 1px;
    background-color: #cccccc;
}

.Quicklogin::before {
    left: 0;
}

.Quicklogin::after {
    right: 0;
}

.Quicklogin-img {
    display: flex;
    justify-content: center;
    position: relative;
}

/* .Quicklogin-img img {
    height: 25px;
    width: 25px;
} */

.linkending {
    height: 2em !important;
    width: 2em !important;
}

.goolebg {
    background-color: #fff;
    color: #1A2332;
    font-size: 1.2857rem;
}

.google_img {
    width: 2.1428rem;
    height: 2.1428rem;
    margin-right: 0.714rem;
}

.apple_img {
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 0.357rem;
}

.mr20 {
    margin-right: 1.4285rem;
}

.account {
    font-size: 1.2857rem;
    color: #111111;
    text-align: center;
}

.forgotDialog_count {
    background-image: url('../assets/images/ForgotPassword.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    padding: 2% 3%;
}

.forgot_img {
    margin-bottom: 3.928em
}

.forgot_img_box {
    width: 20rem;
    height: 3.1428rem;
}

.forgotDialog-box {
    width: 64%;
    /* width: 1130px; */
    margin: auto;
    background-color: #fff;
    padding: 6.85em 15%;
    flex-wrap: wrap;
    display: flex;
    justify-content: center;

}

.account .forgot_txt {
    font-size: 1.2857rem;
}

@media (max-width: 1441px) {

    .Quicklogin::before,
    .Quicklogin::after {

        top: 41%;

    }
}

@media (max-width: 1080px) {

    .Quicklogin::before,
    .Quicklogin::after {

        top: 38.5%;

    }
}

.intensity {
    /* margin-top: -10px; */
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1.4285rem;
}

.log_login {
    height: 100%;
    overflow: auto;
}

.log_login .dialog_cont {
    flex: 1;
    height: 100%;
    overflow: hidden;
    background-color: #fff;

}

/deep/ .el-form-item__error {
    font-size: 1.142857rem;
    color: #F56B6B;
}

.icon_watchun {
    background-image: url("../assets/img/watch_ic1.png");
}

.icon_watchon {
    background-image: url("../assets/img/watch_ic2.png");
}

.g_id_signin {
    position: relative;
    top: 1rem;
    z-index: 99999999;
    left: 3rem;
    top: -4px;
    /* width: 100%; */
    opacity: 0.01;
    pointer-events: all
}

.S9gUrf-YoZ4jf {
    z-index: 99999;
}

.nsm7Bb-HzV7m-LgbsSe {
    background-color: transparent !important;
    border: none !important;
}
</style>
